module.exports = [
  {
    key: 'CAROTID_LEFT',
    label: { en: 'Carotid left', es: '' },
    systolicBPStrengthTuples: [
      [50, 0],
      [60, 1],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Carotid',
  },
  {
    key: 'CAROTID_RIGHT',
    label: { en: 'Carotid Right', es: '' },
    systolicBPStrengthTuples: [
      [50, 0],
      [60, 1],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Carotid',
  },
  {
    key: 'BRACHIAL_UPPER_LEFT',
    label: { en: 'Brachial Left Upper', es: '' },
    systolicBPStrengthTuples: [
      [60, 0],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Brachial Upper',
  },
  {
    key: 'BRACHIAL_UPPER_RIGHT',
    label: { en: 'Brachial Right Upper', es: '' },
    systolicBPStrengthTuples: [
      [60, 0],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Brachial Upper',
  },
  {
    key: 'BRACHIAL_LOWER_LEFT',
    label: { en: 'Brachial Left Lower', es: '' },
    systolicBPStrengthTuples: [
      [60, 0],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Brachial Lower',
  },
  {
    key: 'BRACHIAL_LOWER_RIGHT',
    label: { en: 'Brachial Right Lower', es: '' },
    systolicBPStrengthTuples: [
      [60, 0],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Brachial Lower',
  },
  {
    key: 'FEMORAL_LEFT',
    label: { en: 'Femoral Left', es: '' },
    systolicBPStrengthTuples: [
      [60, 0],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Femoral',
  },
  {
    key: 'FEMORAL_RIGHT',
    label: { en: 'Femoral Right', es: '' },
    systolicBPStrengthTuples: [
      [60, 0],
      [70, 1],
      [80, 3],
      [90, 5],
    ],
    group: 'Femoral',
  },
  {
    key: 'RADIAL_LEFT',
    label: { en: 'Radial Left', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 1],
      [90, 4],
      [120, 5],
    ],
    group: 'Radial',
  },
  {
    key: 'RADIAL_RIGHT',
    label: { en: 'Radial Right', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 1],
      [90, 4],
      [120, 5],
    ],
    group: 'Radial',
  },
  {
    key: 'POPLITEAL_LEFT',
    label: { en: 'Popliteal Left', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 2],
      [90, 4],
      [120, 5],
    ],
    group: 'Popliteal',
  },
  {
    key: 'POPLITEAL_RIGHT',
    label: { en: 'Popliteal Right', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 2],
      [90, 4],
      [120, 5],
    ],
    group: 'Popliteal',
  },
  {
    key: 'POSTERIOR_TIBIAL_LEFT',
    label: { en: 'Posterior Tibial Left', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 0],
      [90, 3],
      [120, 5],
    ],
    group: 'Posterior Tibial',
  },
  {
    key: 'POSTERIOR_TIBIAL_RIGHT',
    label: { en: 'Posterior Tibial Right', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 0],
      [90, 3],
      [120, 5],
    ],
    group: 'Posterior Tibial',
  },
  {
    key: 'DORSALIS_PEDIS_LEFT',
    label: { en: 'Dorsalis Pedis Left', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 0],
      [90, 3],
      [120, 5],
    ],
    group: 'Dorsalis Pedis',
  },
  {
    key: 'DORSALIS_PEDIS_RIGHT',
    label: { en: 'Dorsalis Pedis Right', es: '' },
    systolicBPStrengthTuples: [
      [70, 0],
      [80, 0],
      [90, 3],
      [120, 5],
    ],
    group: 'Dorsalis Pedis',
  },
];
